import { MessageCircle, MousePointer } from 'lucide-react';
import { TRIGGER_TIMEOUT_UNITS } from '../../../flowConstants';

const TRIGGER_TYPES = [
    { value: 'message',      label: 'Se responder',       Icon: MessageCircle },
    { value: 'button_click', label: 'Se clicar no botão', Icon: MousePointer },
];

export default function TriggerNode({ id, data }) {
    const triggerType = data?.triggerType || 'message';
    const triggerTimeoutValue = data?.triggerTimeoutValue ?? 60;
    const triggerTimeoutUnit = data?.triggerTimeoutUnit || 'seconds';

    return (
        <div className="mt-2 space-y-2">
            <div className="flex rounded-md overflow-hidden border border-white/10">
                {TRIGGER_TYPES.map(({ value, label, Icon }) => (
                    <button key={value} type="button"
                        className={`flex-1 flex items-center justify-center gap-1 py-1.5 text-[10px] transition-colors ${
                            triggerType === value
                                ? 'bg-rose-600 text-white'
                                : 'bg-white/5 text-gray-400 hover:bg-white/10'
                        }`}
                        onClick={() => data?.onChangeTrigger?.(id, { triggerType: value })}>
                        <Icon size={11} />{label}
                    </button>
                ))}
            </div>

            <div className="flex items-center gap-2">
                <span className="text-[10px] text-gray-400 shrink-0">Timeout</span>
                <input type="number" min="1" step="1" className="input3 w-24" placeholder="60"
                    value={triggerTimeoutValue}
                    onChange={(e) => data?.onChangeTrigger?.(id, { triggerTimeoutValue: Math.max(1, parseInt(e.target.value) || 1) })} />
                <select className="form-select flex-1" value={triggerTimeoutUnit}
                    onChange={(e) => data?.onChangeTrigger?.(id, { triggerTimeoutUnit: e.target.value })}>
                    {TRIGGER_TIMEOUT_UNITS.map((u) => (
                        <option key={u.value} value={u.value}>{u.label}</option>
                    ))}
                </select>
            </div>

            <div className="flex justify-between text-[9px] font-semibold px-1 pb-1">
                <span className="text-red-400">⏰ Timeout</span>
                <span className="text-emerald-400">✅ OK</span>
            </div>
        </div>
    );
}
